// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"327":"670ea0cf","821":"db24f2f1","995":"543415a0"}[chunkId] + ".js";
};